module.exports = __webpack_public_path__ + "img/SpyTeg.85633af9.png";